"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var store_1 = require("@celestejs/store");
var web3_1 = __importDefault(require("web3"));
var provider_proxy_1 = __importDefault(require("./provider-proxy"));
var constants_1 = require("./constants");
var initialize_1 = require("./sc-utils/initialize");
var validators_1 = require("./validators");
var _store_1$actions = store_1.actions,
  set_address = _store_1$actions.set_address,
  set_readonly_initialized = _store_1$actions.set_readonly_initialized,
  add_web3_readonly_instance = _store_1$actions.add_web3_readonly_instance,
  set_initialized = _store_1$actions.set_initialized,
  set_login_status = _store_1$actions.set_login_status,
  set_web3_instance = _store_1$actions.set_web3_instance,
  set_chain_id = _store_1$actions.set_chain_id,
  set_provider_wallet = _store_1$actions.set_provider_wallet;
function storeWalletData(providerType, provider, config) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var web3, currentChainId, currentAddress;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          web3 = new web3_1["default"](provider);
          _context.next = 3;
          return web3.eth.getChainId();
        case 3:
          currentChainId = _context.sent;
          _context.next = 6;
          return web3.eth.getAccounts();
        case 6:
          currentAddress = _context.sent;
          store_1.store.dispatch(set_address(currentAddress[0]));
          store_1.store.dispatch(set_web3_instance(web3));
          store_1.store.dispatch(set_chain_id(currentChainId));
          store_1.store.dispatch(set_provider_wallet(providerType));
          store_1.store.dispatch(set_login_status(true));
          store_1.store.dispatch(set_initialized(true));
          (0, initialize_1.initSmartContracts)(config, web3, currentChainId);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
function removeWalletData() {
  store_1.store.dispatch(set_address(null));
  store_1.store.dispatch(set_web3_instance(null));
  store_1.store.dispatch(set_chain_id(null));
  store_1.store.dispatch(set_provider_wallet(null));
  store_1.store.dispatch(set_login_status(false));
  store_1.store.dispatch(set_initialized(false));
  (0, initialize_1.removeWriteSmartContracts)();
}
var CelesteJS = /*#__PURE__*/function () {
  function CelesteJS(config) {
    var _this = this;
    (0, _classCallCheck2["default"])(this, CelesteJS);
    this.events = {};
    (0, validators_1.validateConfig)(config);
    this.config = config;
    this.configRead = config;
    var rpcs = config.rpcs,
      smartContracts = config.smartContracts,
      isMultichain = config.isMultichain;
    Object.values(rpcs).forEach(function (rpc) {
      var web3 = new web3_1["default"](rpc.url);
      store_1.store.dispatch(add_web3_readonly_instance(rpc.chainId, web3));
      smartContracts.forEach(function (sc) {
        var address = isMultichain ? sc.address[rpc.chainId] : sc.address;
        if (!address) return;
        if (!Object.values(rpcs).map(function (_rpc) {
          return _rpc.chainId;
        }).includes(rpc.chainId)) {
          console.warn("CelesteJS: config error - chain with id ".concat(rpc.chainId, ", provided on element addressBook.").concat(sc.key, ", is not listen in rpcs."));
          return;
        }
        (0, initialize_1.initSC)(address, sc, web3, "_READ.".concat(rpc.chainId));
      });
      store_1.store.dispatch(set_readonly_initialized(true));
      _this.providerProxy = new provider_proxy_1["default"](Object.values(config.rpcs));
      _this.listenForProviderEvents();
      _this.getPreviousSession();
    });
  }
  (0, _createClass2["default"])(CelesteJS, [{
    key: "getPreviousSession",
    value: function getPreviousSession() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var _this2 = this;
        var listOfProviders, sessions, s;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              listOfProviders = [constants_1.providers.INJECTED, constants_1.providers.CONNECTED];
              _context3.next = 3;
              return Promise.all(listOfProviders.map(function (providerType) {
                return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
                  var provider;
                  return _regenerator["default"].wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        this.providerProxy.setType(providerType);
                        _context2.next = 3;
                        return this.providerProxy.getPreviousSession();
                      case 3:
                        provider = _context2.sent;
                        return _context2.abrupt("return", {
                          providerType: providerType,
                          provider: provider
                        });
                      case 5:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, this);
                }));
              }));
            case 3:
              sessions = _context3.sent;
              s = sessions.find(function (session) {
                return session.provider !== null;
              });
              if (!s) {
                _context3.next = 8;
                break;
              }
              _context3.next = 8;
              return storeWalletData(s.providerType, s.provider, this.config);
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "requestConnection",
    value: function requestConnection(providerType) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              (0, validators_1.validateProviderType)(providerType);
              if (!(0, validators_1.validateIfLoggedIn)()) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return");
            case 3:
              this.providerProxy.setType(providerType);
              _context4.next = 6;
              return this.providerProxy.requestConnection();
            case 6:
              _context4.next = 8;
              return storeWalletData(providerType, this.providerProxy.getProvider(providerType), this.config);
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "requestDisconnection",
    value: function requestDisconnection() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var providerType;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if ((0, validators_1.validateIfLoggedIn)()) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              providerType = store_1.store.getState().walletReducer.providerWallet;
              this.providerProxy.setType(providerType);
              _context5.next = 6;
              return this.providerProxy.requestDisconnection();
            case 6:
              removeWalletData();
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "requestChangeNetwork",
    value: function requestChangeNetwork(chainId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var providerType;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              (0, validators_1.validateChainId)(chainId);
              if ((0, validators_1.validateIfLoggedIn)()) {
                _context6.next = 3;
                break;
              }
              return _context6.abrupt("return");
            case 3:
              providerType = store_1.store.getState().walletReducer.providerWallet;
              this.providerProxy.setType(providerType);
              this.providerProxy.requestChangeNetwork(chainId);
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "listenForProviderEvents",
    value: function listenForProviderEvents() {
      var _this3 = this;
      var ethProvider = this.providerProxy.getProvider(constants_1.providers.INJECTED);
      var wcProvider = this.providerProxy.getProvider(constants_1.providers.CONNECTED);
      if (ethProvider) {
        ethProvider.removeAllListeners();
        ethProvider.on('accountsChanged', function (accounts) {
          _this3.accountsChanged(accounts);
          _this3.events.accountsChanged && _this3.events.accountsChanged(accounts);
        });
        ethProvider.on('chainChanged', function (chainId) {
          var chainIdNum = Number(chainId);
          _this3.chainChanged(chainIdNum);
          _this3.events.chainChanged && _this3.events.chainChanged(chainId);
        });
        ethProvider.on('connect', function (args) {
          _this3.events.connect && _this3.events.connect(args);
        });
        ethProvider.on('disconnect', function (error) {
          _this3.events.disconnect && _this3.events.disconnect(error);
        });
      }
      if (wcProvider) {
        wcProvider.removeAllListeners();
        wcProvider.on('accountsChanged', function (accounts) {
          _this3.accountsChanged(accounts);
          _this3.events.accountsChanged && _this3.events.accountsChanged(accounts);
        });
        wcProvider.on('chainChanged', function (chainId) {
          var chainIdNum = Number(chainId);
          _this3.chainChanged(chainIdNum);
          _this3.events.chainChanged && _this3.events.chainChanged(chainId);
        });
        wcProvider.on('disconnect', function (code, reason) {
          if (code === 1000) {
            _this3.accountsChanged([]);
          } else {
            console.error('Wallet disconnected', code, reason);
          }
          _this3.events.disconnect && _this3.events.disconnect(code, reason);
        });
      }
    }
  }, {
    key: "accountsChanged",
    value: function accountsChanged(accounts) {
      if (!(accounts.length > 0)) {
        removeWalletData();
      } else {
        store_1.store.dispatch(set_address(accounts[0]));
      }
    }
  }, {
    key: "chainChanged",
    value: function chainChanged(chainId) {
      store_1.store.dispatch(set_chain_id(chainId));
      if (!(0, validators_1.validateIfLoggedIn)()) return;
      (0, initialize_1.removeWriteSmartContracts)();
      var rpcs = this.config.rpcs;
      var chainIds = Object.values(rpcs).map(function (rpc) {
        return +rpc.chainId;
      });
      if (!chainIds.includes(+chainId)) return;
      var providerType = store_1.store.getState().walletReducer.providerWallet;
      var provider = this.providerProxy.getProvider(providerType);
      storeWalletData(providerType, provider, this.config);
    }
  }, {
    key: "on",
    value: function on(eventKey, callback) {
      if (!Object.values(constants_1.events).includes(eventKey)) throw new Error("Event ".concat(eventKey, " does not exist"));
      this.events[eventKey] = callback;
    }
  }]);
  return CelesteJS;
}();
exports["default"] = CelesteJS;